import { Container, Typography, Box, Paper, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ROLES } from '../../utils/roles';

function Sitemap() {
  const { currentUser, userRole } = useAuth();

  const isAdmin = userRole === ROLES.ADMIN;
  const isEtudiant = userRole === ROLES.ETUDIANT;
  const isPilote = userRole === ROLES.PILOTE;

  // Calculer le nombre total de sections à afficher
  const totalSections = 2 + // Pages principales, Informations légales
    (!isAdmin && currentUser ? 1 : 0) + // Espace utilisateur (si connecté et non admin)
    (isAdmin ? 1 : 0) +
    (isEtudiant ? 1 : 0) +
    (isPilote ? 1 : 0);

  // Calculer la largeur en fonction du nombre de sections
  const getFlexBasis = () => {
    if (totalSections <= 3) return '33%';
    if (totalSections === 4) return '45%';
    return '33%'; // Pour 5 et 6 sections
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom align="center" sx={{ mb: 6 }}>
          Plan du site
        </Typography>

        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: { xs: 3, md: 8 },
          justifyContent: 'center',
          maxWidth: '900px',
          mx: 'auto'
        }}>
          {/* Pages principales */}
          <Box sx={{ 
            flexBasis: getFlexBasis(),
            minWidth: '250px',
            flexGrow: 0,
            flexShrink: 0,
            textAlign: 'center'
          }}>
            <Typography variant="h6" gutterBottom>
              Pages principales
            </Typography>
            <Box>
              <Link component={RouterLink} to="/" sx={{ display: 'block', mb: 1 }}>
                Accueil
              </Link>
              <Link component={RouterLink} to="/entreprises" sx={{ display: 'block', mb: 1 }}>
                Entreprises
              </Link>
              <Link component={RouterLink} to="/offres" sx={{ display: 'block', mb: 1 }}>
                Offres de stage
              </Link>
              <Link component={RouterLink} to="/stats" sx={{ display: 'block', mb: 1 }}>
                Statistiques
              </Link>
            </Box>
          </Box>

          {/* Pages Étudiant */}
          {isEtudiant && (
            <Box sx={{ 
              flexBasis: getFlexBasis(),
              minWidth: '250px',
              flexGrow: 0,
              flexShrink: 0,
              textAlign: 'center'
            }}>
              <Typography variant="h6" gutterBottom>
                Espace Étudiant
              </Typography>
              <Box>
                <Link component={RouterLink} to="/wishlist" sx={{ display: 'block', mb: 1 }}>
                  Wishlist
                </Link>
                <Link component={RouterLink} to="/candidatures" sx={{ display: 'block', mb: 1 }}>
                  Mes candidatures
                </Link>
              </Box>
            </Box>
          )}

          {/* Pages Admin */}
          {isAdmin && (
            <Box sx={{ 
              flexBasis: getFlexBasis(),
              minWidth: '250px',
              flexGrow: 0,
              flexShrink: 0,
              textAlign: 'center'
            }}>
              <Typography variant="h6" gutterBottom>
                Administration
              </Typography>
              <Box>
                <Link component={RouterLink} to="/etudiants" sx={{ display: 'block', mb: 1 }}>
                  Étudiants
                </Link>
                <Link component={RouterLink} to="/pilotes" sx={{ display: 'block', mb: 1 }}>
                  Pilotes
                </Link>
                <Link component={RouterLink} to="/admin" sx={{ display: 'block', mb: 1 }}>
                  Administration
                </Link>
              </Box>
            </Box>
          )}

          {/* Pages Pilote */}
          {isPilote && (
            <Box sx={{ 
              flexBasis: getFlexBasis(),
              minWidth: '250px',
              flexGrow: 0,
              flexShrink: 0,
              textAlign: 'center'
            }}>
              <Typography variant="h6" gutterBottom>
                Espace Pilote
              </Typography>
              <Box>
                <Link component={RouterLink} to="/etudiants" sx={{ display: 'block', mb: 1 }}>
                  Étudiants
                </Link>
              </Box>
            </Box>
          )}

          {/* Espace utilisateur - Modifié pour exclure les admins */}
          {currentUser && !isAdmin ? (
            <Box sx={{ 
              flexBasis: getFlexBasis(),
              minWidth: '250px',
              flexGrow: 0,
              flexShrink: 0,
              textAlign: 'center'
            }}>
              <Typography variant="h6" gutterBottom>
                Espace utilisateur
              </Typography>
              <Box>
                <Link component={RouterLink} to="/profil" sx={{ display: 'block', mb: 1 }}>
                  Mon profil
                </Link>
              </Box>
            </Box>
          ) : !currentUser && (
            <Box sx={{ 
              flexBasis: getFlexBasis(),
              minWidth: '250px',
              flexGrow: 0,
              flexShrink: 0,
              textAlign: 'center'
            }}>
              <Typography variant="h6" gutterBottom>
                Espace utilisateur
              </Typography>
              <Box>
                <Link component={RouterLink} to="/login" sx={{ display: 'block', mb: 1 }}>
                  Connexion
                </Link>
              </Box>
            </Box>
          )}

          {/* Informations légales */}
          <Box sx={{ 
            flexBasis: getFlexBasis(),
            minWidth: '250px',
            flexGrow: 0,
            flexShrink: 0,
            textAlign: 'center'
          }}>
            <Typography variant="h6" gutterBottom>
              Informations légales
            </Typography>
            <Box>
              <Link component={RouterLink} to="/mentions-legales" sx={{ display: 'block', mb: 1 }}>
                Mentions légales
              </Link>
              <Link component={RouterLink} to="/plan-du-site" sx={{ display: 'block', mb: 1 }}>
                Plan du site
              </Link>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}

export default Sitemap;
